document.addEventListener('DOMContentLoaded', function () {
	const menuBtn = document.querySelector('.menu-btn');
	const mobileMenu = document.querySelector('.mobile-menu');
	const navBar = document.querySelector('.navbar');

	if (menuBtn && mobileMenu) {
		menuBtn.addEventListener('click', function () {
			mobileMenu.classList.toggle('active');
			menuBtn.classList.toggle('active');
			navBar.classList.toggle('active');
		});

		// Ensure menu closes when resizing above 1200px
		window.addEventListener('resize', function () {
			if (window.innerWidth > 1200) {
				mobileMenu.classList.remove('active');
				menuBtn.classList.remove('active');
				navBar.classList.remove('active');
			}
		});
	}
});

//Submenu Desktop
(function () {
	'use strict';

	const menuItems = document.querySelectorAll('.nav-menu > li.menu-item-has-children');
	if (!menuItems.length) return;

	let closeTimer;

	menuItems.forEach((item, idx) => {
		const link = item.querySelector('a');
		const submenu = item.querySelector('.sub-menu');

		if (!link || !submenu) return;

		// === Add ARIA attributes ===
		const submenuId = `submenu-${idx + 1}`;
		link.setAttribute('aria-haspopup', 'menu');
		link.setAttribute('aria-expanded', 'false');
		link.setAttribute('aria-controls', submenuId);
		submenu.setAttribute('role', 'menu');
		submenu.setAttribute('id', submenuId);
		submenu.querySelectorAll('li > a').forEach(subLink => {
			subLink.setAttribute('role', 'menuitem');
		});

		// === Hover Behavior (Desktop) ===
		item.addEventListener('mouseenter', () => {
			clearTimeout(closeTimer);
			closeAllSubmenus(item);
			item.classList.add('is-open');
			link.setAttribute('aria-expanded', 'true');
		});

		item.addEventListener('mouseleave', () => {
			closeTimer = setTimeout(() => {
				item.classList.remove('is-open');
				link.setAttribute('aria-expanded', 'false');
			}, 120);
		});

		// When hovering back from submenu to parent link, keep submenu open (link is inside item so item doesn't fire mouseenter)
		link.addEventListener('mouseenter', () => {
			clearTimeout(closeTimer);
			item.classList.add('is-open');
			link.setAttribute('aria-expanded', 'true');
		});

		// Keep open when hovering submenu
		submenu.addEventListener('mouseenter', () => clearTimeout(closeTimer));
		submenu.addEventListener('mouseleave', () => {
			closeTimer = setTimeout(() => {
				item.classList.remove('is-open');
				link.setAttribute('aria-expanded', 'false');
			}, 120);
		});

		// === Click Behavior (Touch) ===
		link.addEventListener('click', e => {
			const isTouch = window.matchMedia('(hover: none)').matches;
			if (!isTouch) return;

			const isOpen = item.classList.contains('is-open');
			if (!isOpen) {
				e.preventDefault();
				closeAllSubmenus();
				item.classList.add('is-open');
				link.setAttribute('aria-expanded', 'true');
			} else {
				item.classList.remove('is-open');
				link.setAttribute('aria-expanded', 'false');
			}
		});

		// === Keyboard Accessibility ===
		link.addEventListener('keydown', e => {
			const submenuLinks = submenu.querySelectorAll('a');
			switch (e.key) {
				case 'Enter':
				case ' ':
					e.preventDefault();
					toggleSubmenu(item, submenu, link);
					break;
				case 'ArrowDown':
					e.preventDefault();
					openAndFocusFirst(item, submenu, link);
					break;
				case 'Escape':
					item.classList.remove('is-open');
					link.setAttribute('aria-expanded', 'false');
					link.focus();
					break;
			}
		});

		// Submenu keyboard navigation
		const submenuLinks = submenu.querySelectorAll('a');
		submenuLinks.forEach((subLink, index) => {
			subLink.addEventListener('keydown', e => {
				switch (e.key) {
					case 'ArrowDown':
						e.preventDefault();
						submenuLinks[index + 1]?.focus();
						break;
					case 'ArrowUp':
						e.preventDefault();
						if (index === 0) link.focus();
						else submenuLinks[index - 1]?.focus();
						break;
					case 'Escape':
						e.preventDefault();
						item.classList.remove('is-open');
						link.setAttribute('aria-expanded', 'false');
						link.focus();
						break;
				}
			});
		});
	});

	// Outside click closes
	document.addEventListener('click', e => {
		if (!e.target.closest('.nav-menu')) closeAllSubmenus();
	});

	// === Helper functions ===
	function toggleSubmenu(item, submenu, link) {
		const isOpen = item.classList.contains('is-open');
		closeAllSubmenus();
		item.classList.toggle('is-open', !isOpen);
		link.setAttribute('aria-expanded', !isOpen);
		if (!isOpen) submenu.querySelector('a')?.focus();
	}

	function openAndFocusFirst(item, submenu, link) {
		closeAllSubmenus();
		item.classList.add('is-open');
		link.setAttribute('aria-expanded', 'true');
		submenu.querySelector('a')?.focus();
	}

	function closeAllSubmenus(except) {
		menuItems.forEach(item => {
			const link = item.querySelector('a');
			if (item !== except) {
				item.classList.remove('is-open');
				link?.setAttribute('aria-expanded', 'false');
			}
		});
	}
})();

// Submenu Mobiles

document.addEventListener('DOMContentLoaded', function () {
	const menuItems = document.querySelectorAll('.menu-item-has-children');
	const mobileMenu = document.querySelector('.mobile-menu');

	// Hamburger menu and close button
	const hamburger = document.querySelector('.hamburger'); // your hamburger icon
	const closeIcon = document.querySelector('.close-icon'); // your close icon inside mobile-menu

	// ================================
	// 1. Open mobile menu on hamburger click
	// ================================
	if (hamburger) {
		hamburger.addEventListener('click', function () {
			if (mobileMenu) {
				mobileMenu.classList.add('active');
			}
		});
	}

	// ================================
	// 3. Add submenu toggle buttons for items with children
	// ================================
	menuItems.forEach(item => {
		const link = item.querySelector('a');
		const subMenu = item.querySelector('.sub-menu');

		// Add Toggle Button (Arrow)
		const toggleBtn = document.createElement('button');
		toggleBtn.classList.add('submenu-toggle');
		toggleBtn.setAttribute('aria-expanded', 'false');
		toggleBtn.setAttribute('aria-label', 'Toggle Submenu');
		item.insertBefore(toggleBtn, subMenu);

		// Expand/Close on tap (button)
		toggleBtn.addEventListener('click', e => {
			e.preventDefault();
			const isOpen = item.classList.toggle('submenu-open');
			toggleBtn.setAttribute('aria-expanded', isOpen);
		});

		// On mobile: clicking the link text also toggles the submenu (don't navigate)
		if (link && item.closest('.mobile-menu')) {
			link.addEventListener('click', e => {
				e.preventDefault();
				const isOpen = item.classList.toggle('submenu-open');
				toggleBtn.setAttribute('aria-expanded', isOpen);
			});

			// On mobile: clicking anywhere in the parent li (except parent link, toggle, or submenu links) toggles the submenu
			item.addEventListener('click', e => {
				// Let submenu links navigate normally
				if (e.target.closest('.sub-menu a')) return;
				// Parent link and toggle have their own toggle handlers
				if (e.target === link || link.contains(e.target)) return;
				if (e.target === toggleBtn || toggleBtn.contains(e.target)) return;

				e.preventDefault();
				const isOpen = item.classList.toggle('submenu-open');
				toggleBtn.setAttribute('aria-expanded', isOpen);
			});
		}
	});

	// ================================
	// 4. Tap outside closes mobile menu
	// ================================
	document.addEventListener('click', e => {
		if (
			mobileMenu &&
			mobileMenu.classList.contains('active') &&
			!mobileMenu.contains(e.target) &&
			!hamburger.contains(e.target)
		) {
			mobileMenu.classList.remove('active');
			// Reset any open submenus
			document
				.querySelectorAll('.submenu-open')
				.forEach(el => el.classList.remove('submenu-open'));
		}
	});
});
